import actions from './actions';

const initState = {
    data: []
};

export default function EquipmentCommentReducer(state = initState, action) {
    switch (action.type) {
        case actions.EquipmentComment_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
